module.exports = __webpack_public_path__ + "img/label-disabled.c1e110d3.svg";